"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidDatalayerNativeEvents = void 0;
var FluidAlertEvents;
(function (FluidAlertEvents) {
    FluidAlertEvents["ALERT_DISMISSED"] = "alertDismissed";
    FluidAlertEvents["ALERT_SHOWN"] = "alertShown";
})(FluidAlertEvents || (FluidAlertEvents = {}));
var FluidButtonEvents;
(function (FluidButtonEvents) {
    FluidButtonEvents["BLUR"] = "blur";
    FluidButtonEvents["CLICK"] = "click";
    FluidButtonEvents["HOVER"] = "hover";
})(FluidButtonEvents || (FluidButtonEvents = {}));
var FluidDropdownButtonEvents;
(function (FluidDropdownButtonEvents) {
    FluidDropdownButtonEvents["LINK_CLICKED"] = "linkClicked";
})(FluidDropdownButtonEvents || (FluidDropdownButtonEvents = {}));
var FluidFormEvents;
(function (FluidFormEvents) {
    FluidFormEvents["VALUE_CHANGE"] = "valueChange";
})(FluidFormEvents || (FluidFormEvents = {}));
var FluidSelectEvents;
(function (FluidSelectEvents) {
    FluidSelectEvents["SELECTION_CLEARED"] = "selectionCleared";
    FluidSelectEvents["SELECTED"] = "selected";
})(FluidSelectEvents || (FluidSelectEvents = {}));
var FluidTableEvents;
(function (FluidTableEvents) {
    FluidTableEvents["TABLE_SEARCHED"] = "tableSearched";
    FluidTableEvents["TABLE_SORTED"] = "tableSorted";
    FluidTableEvents["TABLE_FILTERED"] = "tableFiltered";
})(FluidTableEvents || (FluidTableEvents = {}));
exports.FluidDatalayerNativeEvents = {
    FluidTable: FluidTableEvents,
    FluidSelect: FluidSelectEvents,
    FluidForm: FluidFormEvents,
    FluidDropdownButton: FluidDropdownButtonEvents,
    FluidButton: FluidButtonEvents,
    FluidAlert: FluidAlertEvents
};
